import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=175fa44c&scoped=true"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=175fa44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175fa44c",
  null
  
)

export default component.exports